module.exports = {"533323101":"上帕镇","533323201":"匹河怒族乡","533323202":"子里甲乡","533323203":"架科底乡","533323204":"鹿马登乡","533323205":"石月亮乡","533323206":"马吉乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/533323.json
// module id = 2803
// module chunks = 0